export default defineNuxtPlugin((nuxtApp) => {
  const errorStore = useErrorStore()
  const notificationStore = useNotificationStore()

  nuxtApp.vueApp.config.errorHandler = (err, instance, info) => {
    console.error('[Global Error Handler]', err, info)

    const errorContext = {
      message: err.message || 'An unexpected error occurred',
      stack: err.stack,
      componentName: instance?.$options?.name || instance?.$?.type?.name || 'Unknown Component',
      info,
      timestamp: new Date().toISOString(),
    }

    errorStore.addError({
      type: 'vue-error',
      message: errorContext.message,
      component: errorContext.componentName,
      timestamp: errorContext.timestamp,
      stack: errorContext.stack,
    })

    if (import.meta.env.DEV) {
      console.error('[Error Context]', errorContext)
    }

    notificationStore.add({
      type: 'error',
      title: 'Application Error',
      message: import.meta.env.DEV
        ? `${errorContext.message} in ${errorContext.componentName}`
        : 'Something went wrong. Please try again.',
      duration: 5000,
    })
  }

  nuxtApp.hook('vue:error', (err, instance, info) => {
    console.error('[Vue Error Hook]', err, info)
  })

  nuxtApp.hook('app:error', (err) => {
    console.error('[App Error Hook]', err)

    errorStore.addError({
      type: 'app-error',
      message: err.message || 'Application error',
      timestamp: new Date().toISOString(),
      stack: err.stack,
    })
  })

  window.addEventListener('unhandledrejection', (event) => {
    console.error('[Unhandled Promise Rejection]', event.reason)

    errorStore.addError({
      type: 'promise-rejection',
      message: event.reason?.message || 'Unhandled promise rejection',
      timestamp: new Date().toISOString(),
      stack: event.reason?.stack,
    })

    notificationStore.add({
      type: 'error',
      title: 'Async Error',
      message: import.meta.env.DEV
        ? event.reason?.message || 'An async operation failed'
        : 'An operation failed. Please try again.',
      duration: 5000,
    })

    event.preventDefault()
  })

  window.addEventListener('error', (event) => {
    console.error('[Global Error Event]', event.error)

    if (event.error) {
      errorStore.addError({
        type: 'runtime-error',
        message: event.error.message || 'Runtime error',
        timestamp: new Date().toISOString(),
        stack: event.error.stack,
      })
    }
  })
})
